"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adapt2Runtime = exports.RuntimeDataSourceItem = void 0;
var RuntimeDataSourceItem_1 = require("./RuntimeDataSourceItem");
Object.defineProperty(exports, "RuntimeDataSourceItem", { enumerable: true, get: function () { return RuntimeDataSourceItem_1.RuntimeDataSourceItem; } });
var adapter_1 = require("./adapter");
Object.defineProperty(exports, "adapt2Runtime", { enumerable: true, get: function () { return adapter_1.adapt2Runtime; } });
